<template>
  <div
    class="w-[256px] h-[220px] rounded-2 flex gap-1 flex-col items-center box-border justify-center content-grid-raw__item__deleted"
    @click="emit('click')"
  >
    <CIcon :color="themeVars.primary2" icon="trash-can" size="24px" />
    <div class="flex items-center flex-col justify-center">
      <div class="text-center font-400 text-truncate font-size-4 line-height-6 color-text font-normal">
        {{ t('canvasUI.canvasBuilder.deletedFile.deleteMessage') }}
      </div>
      <div class="text-center text-truncate font-size-3 line-height-5 color-text font-normal">
        {{ t('canvasUI.canvasBuilder.deletedFile.clickMessage') }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { useI18n } from 'vue-i18n'

const emit = defineEmits<{
  (e: 'click'): void
}>()
const themeVars = useThemeVars()
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.content-grid-raw__item__deleted {
  background-color: v-bind('themeVars.primary6');
}

.color-text {
  color: v-bind('themeVars.primary2');
}
</style>
